export const banditIdle = new Image();
banditIdle.src = "assets/characterSprites/bandit/HeavyBandit.png";
banditIdle.width = 48;
banditIdle.height = 48;
banditIdle.yOffset = 95
banditIdle.xOffset = 200
banditIdle.cycleLoop = [0, 0, 1, 1, 2, 2, 3, 3];
